const state = {
	showDrawer: false,
	clicked: false,
}

const getters = {
	showDrawer: (state) => state.showDrawer,
	getClickState: (state) => state.clicked,
}

const actions = {
	setShowDrawer({ commit }, show) {
		commit('showDrawer', show)
	},

	setClicked({ commit }, clicked) {
		commit('clickedAction', clicked)
	},
}

const mutations = {
	showDrawer: (state, show) => (state.showDrawer = show),
	clickedAction: (state, clicked) => (state.clicked = clicked),
}

export default {
	state,
	getters,
	actions,
	mutations,
}
